import { ConfirmationDialog } from 'app/components/dialogs';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * @deprecated This dialog is deprecated and must be replaced with a separate page
 */
export default function InitializationError() {
  const { t } = useTranslation();

  return (
    <ConfirmationDialog
      open
      title={t('unexpected_error_title')}
      confirmationLabel={t('ok')}
      onConfirm={() => window.location.reload()}
    >
      <span style={{ display: 'block', marginBottom: '10px' }}>
        {t('having_issues_with_app')}
      </span>
    </ConfirmationDialog>
  );
}
